import { Link } from 'react-router-dom';

export const parseMentions = (text: string, currentUsername?: string) => {
  const parts = text.split(/(@\w+)/g);
  
  return parts.map((part, index) => {
    if (part.match(/^@\w+$/)) {
      const username = part.slice(1);
      // If it's the current user's mention, link to their profile page
      const isCurrentUser = currentUsername && username.toLowerCase() === currentUsername.toLowerCase();
      const linkTo = isCurrentUser ? '/profile' : `/user/${username}`;
      
      return (
        <Link
          key={index}
          to={linkTo}
          className="text-primary hover:underline font-medium"
          onClick={(e) => e.stopPropagation()}
        >
          {part}
        </Link>
      );
    }
    return <span key={index}>{part}</span>;
  });
};

export const extractMentions = (text: string): string[] => {
  const matches = text.match(/@(\w+)/g);
  return matches ? matches.map(m => m.slice(1)) : [];
};
